import { jsx as e, jsxs as c } from "react/jsx-runtime";
import l from "./table.module.less.js";
const h = ({ columns: n, data: d }) => /* @__PURE__ */ e("div", { children: /* @__PURE__ */ c("table", { className: `${l.table}`, children: [
  /* @__PURE__ */ e("thead", { className: l.tableHead, children: /* @__PURE__ */ e("tr", { children: n.map((a, r) => /* @__PURE__ */ e(
    "td",
    {
      className: `${l.cell} ${r > 0 ? l.alignRight : ""} body-base bold`,
      children: a
    },
    a + "-" + r
  )) }) }),
  /* @__PURE__ */ e("tbody", { children: d.map((a) => /* @__PURE__ */ e("tr", { className: l.row, children: Object.entries(a).map(([r, s], t) => /* @__PURE__ */ c("td", { className: `${l.cell} ${t > 0 ? l.alignRight : ""}`, children: [
    /* @__PURE__ */ e("span", { className: l.columnLabel, children: r }),
    /* @__PURE__ */ e("span", { children: s })
  ] }, t + "-" + s)) })) })
] }) });
export {
  h as Table,
  h as default
};
